import { Box, Text, Button, Flex, Icon, Link } from '@chakra-ui/react';
import { EXTENSION_ID } from '@/constants/app-constants';
import { GoogleChrome, InfoCircle } from '@kula-ai/icons-core';

export const ExtensionNudge = () => {
  return (
    <Flex bg="rgba(0, 67, 206, 0.1)" px="24px" py="8px" alignItems="center">
      <Flex flex="1">
        <Icon
          as={InfoCircle}
          width="20px"
          height="20px"
          color="var(--kula-dark-primary-700, #0043CE)"
        />
        <Box ml="12px">
          <Text fontWeight="semiBold" fontSize="14px">
            Install Kula Everywhere
          </Text>
          <Text>
            Add your candidates to flow seamlessly via Kula Everywhere. Our
            extension currently supports multiple websites, including LinkedIn,
            Github, and more.
          </Text>
        </Box>
      </Flex>
      <Link
        color="brand.100"
        href={`https://chrome.google.com/webstore/detail/kula-everywhere-developme/${EXTENSION_ID}`}
        target="_blank"
      >
        <Button leftIcon={<GoogleChrome width="16px" height="16px" />}>
          Install Extension
        </Button>
      </Link>
    </Flex>
  );
};
